import { ca } from '@cian/analytics';

import { EStatus } from '../../../types/likes';

type TLabel = 'Like' | 'Dislike' | 'Undo_Like' | 'Undo_Dislike';
interface IPage {
  dealType?: string | null;
  objectType?: string | null;
  offerID?: number;
  offerPhone?: string;
  pageType?: string;
  siteType?: string;
  extra: {
    review_id?: string;
    question_id?: string;
    type: string;
    rating: number | null;
  };
}

export function mapLabelFromState({ currentState, nextState }: { currentState: EStatus; nextState: EStatus }): TLabel {
  const map = {
    [EStatus.Disliked]: {
      [EStatus.Liked]: 'Like' as const,
      [EStatus.Unknown]: 'Undo_Dislike' as const,
      [EStatus.Disliked]: 'Dislike' as const,
    },
    [EStatus.Liked]: {
      [EStatus.Disliked]: 'Dislike' as const,
      [EStatus.Unknown]: 'Undo_Like' as const,
      [EStatus.Liked]: 'Like' as const,
    },
    [EStatus.Unknown]: {
      [EStatus.Disliked]: 'Dislike' as const,
      [EStatus.Liked]: 'Like' as const,
      [EStatus.Unknown]: 'Like' as const,
    },
  };

  return map[currentState][nextState];
}

export function trackReactionAnalyticClick({ label, page }: { label: TLabel; page: IPage }) {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'NewbuildingReviews',
    label,
    name: 'oldevent',
    useLastProducts: true,
    page: page as unknown as Record<string, unknown>,
  });
}
